import styled from '@emotion/styled';
import { Select } from '@mui/material';
import { shouldForwardProps } from '../../utils';
import { LabelLarge } from '../../styles';

const EllipsisText = styled(LabelLarge)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

const SingleSelectBaseSelect = styled(Select, shouldForwardProps)<{
    isSelected: boolean;
    noMaxWidth: boolean;
}>`
    width: fit-content;
    max-width: ${({ noMaxWidth }) => (noMaxWidth ? '' : '185px')};
    border-radius: ${({ theme }) => theme.spacing(1)};
    background-color: white;
    height: 32px;

    .MuiSelect-select {
        padding: ${({ theme, isSelected }) =>
            isSelected ? theme.spacing(1) : `${theme.spacing(1)} ${theme.spacing(2)}`};
    }

    .MuiOutlinedInput-notchedOutline {
        border: ${({ theme, isSelected }) =>
            `1px solid ${isSelected ? theme.colors.primaryContainer : theme.colors.outline}`};
        border-radius: ${({ theme }) => theme.spacing(1)};
    }
`;

export { EllipsisText, SingleSelectBaseSelect };
